































































import TagChip from "@/components/tag/TagChip.vue";
import { BackendResourceEnum } from "@/store/enum/authResourceEnum";
import { PageFilterOperationEnum } from "@/lib/utility/data/page-filter-operation.enum";
import { handleError } from "@/lib/utility/handleError";
import { ITag } from "@/models/tag.entity";
import { PageFilterElement } from "@/models/page-filter-element.entity";
import { ActionEnum } from "@/store/enum/authActionEnum";
import { UserModule } from "@/store/modules/me-user.store";
import { PartnerModule } from "@/store/modules/partner";
import { RefsTagModule } from "@/store/modules/refs.store";
import { debounce } from "debounce";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { TagGoToHelper } from "@/lib/utility/tag.go-to-helper";

@Component({
  components: { TagChip },
  filters: {}
})
export default class SelectTags extends Vue {
  readonly TagGoToHelper = TagGoToHelper;

  loadingLocal = false;
  search = "";
  menuWidth = 400;

  @Prop({ default: () => [] })
  value!: ITag[];

  @Prop({ required: true })
  resource!: BackendResourceEnum;

  @Prop({ default: false })
  disabled!: boolean;

  @Prop({ default: false })
  readonly!: boolean;

  @Prop({ default: false })
  loading!: boolean;

  get selectedTags(): ITag[] {
    return this.value;
  }

  set selectedTags(value: ITag[]) {
    this.$emit("input", value);
    this.$emit("change", value);
  }

  get isLoading(): boolean {
    return this.loading || this.loadingLocal;
  }

  get partner() {
    return PartnerModule.partner;
  }

  get partnerId() {
    return this.partner.id;
  }

  get items() {
    const filteredItems = RefsTagModule.filteredAndSorted || [];
    const selectedItems = this.selectedTags || [];

    const filteredItemIds = new Set(filteredItems.map(item => item.id));
    const missingSelectedItems = selectedItems.filter(tag => !filteredItemIds.has(tag.id));

    return [...filteredItems, ...missingSelectedItems];
  }

  get tagFilter() {
    return new PageFilterElement({
      key: "resources",
      operation: PageFilterOperationEnum.EQUAL,
      value: this.resource
    });
  }

  @Watch("search")
  async onSearchChange(search: string) {
    if (search && !this.itemsExist(search)) {
      this.debounceQuerySelections(search);
    }
  }

  private itemsExist(tagValue: string) {
    return this.items && this.items.some(i => i.value === tagValue);
  }

  private openManageTags() {
    new TagGoToHelper(this.$router).goToTagTable({
      partnerId: this.partnerId,
      newTab: true
    });
  }

  // We have to debounce the input of the user to not fire backend calls after each keystroke
  debounceQuerySelections = debounce(this.querySelections, 500);

  /**
   *  Searches the API directly not via the store
   * @param search the search parameter
   */
  async querySelections(search: string) {
    this.loadingLocal = true;

    try {
      if (UserModule.abilities.can(ActionEnum.READ, BackendResourceEnum.TAG, this.partnerId)) {
        RefsTagModule.setFilters([this.tagFilter]);
        RefsTagModule.setSearch(search);
        await RefsTagModule.fetchFirstPage({ partnerId: this.partnerId });
      }
    } catch (error) {
      handleError(error);
    } finally {
      this.loadingLocal = false;
    }
  }

  mounted() {
    RefsTagModule.setFilters([this.tagFilter]);
    this.querySelections("");

    this.$nextTick(() => {
      const container = this.$refs.container as HTMLElement;
      if (container) {
        this.menuWidth = container.offsetWidth;
      }
    });
  }

  beforeDestroy() {
    RefsTagModule.setFilters([]);
    RefsTagModule.setSearch("");
  }
}
